import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom'
import './App.scss';
import scheduleJSON from './data/data'
import TripDetails from './TripDetails'
import ImportantInfo from './ImportantInfo'
import Button from '@material-ui/core/Button'


function DaysRows() {
  const { schedule } = scheduleJSON
  return schedule.map((day, idx) => {
    const { no, title, summary } = day.overview
    return (
      <tr key={idx}>
        <td>
          <h3>{`Day ${no} - ${title}`}</h3>
          <span className="summary">
            {`${summary}`}
          </span>
          {/* <div className="pictures">
            Pictures
          </div> */}
          <p>
            <Button variant='contained' disableElevation size='large'>
              <Link to={`/details/${idx}`}>More Details</Link>
            </Button>
          </p>
        </td>
      </tr>
    )
  })
}

function ScheduleTable() {
  return (
    <table id="overview-schedule-table">
      <tbody>
        <DaysRows />
      </tbody>
    </table>
  )
}

function OverViewSchedule() {
  return (
    <div>
      <ScheduleTable />
    </div>
  )
}

function Container() {
  useEffect(() => {
    window.scrollTo(0,0)
  })

  return (
    <div className="App">
      <header className="container">
        <h1>USA Trip 2020</h1>
        <h2>Itenerary</h2>
        <OverViewSchedule />
        <h2>Important Info</h2>
        <Button variant='contained' color="secondary" disableElevation size='large'>
          <Link to='/contacts'>Important Info</Link>
        </Button>
        <p>Coronavirus Info & Precautions, Thomas Cook Contact Info, etc</p>
      </header>
    </div>
  )
}

function App() {
  return (
    <Router>
      <Switch>
        <Route path='/details/:idx'>
          <TripDetails />
        </Route>
        <Route path='/contacts'>
          <ImportantInfo />
        </Route>
        <Route path='/'>
          <Container />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
